import { render } from "./VmsSidebarCamerasTabListItem.vue?vue&type=template&id=226a5080&ts=true"
import script from "./VmsSidebarCamerasTabListItem.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabListItem.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabListItem.vue?vue&type=style&index=0&id=226a5080&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__